export const ADMIN_LIST = 'ADMIN_LIST';
export const ADMIN_UPDATE_ADMIN = 'ADMIN_UPDATE_ADMIN';
export const CREATE_ADMIN = 'CREATE_ADMIN'; 
export const GET_ROLE_LIST = 'GET_ROLE_LIST'; 

